import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Nav from '../../Nav';
import renderNavItems from '../../../_shared/helpers/renderNavItems';
import filterNavItems from '../../../_shared/helpers/filterNavItems';
import renderLocale from '../../../_shared/helpers/renderLocale';
import ReducerConstants from '../../../_shared/constants/reducers';
import { login } from '../../../redux/slices/auth';
import IntercomService from '../../../services/IntercomService';
import MixpanelService from '../../../services/MixpanelService';
import { updateActivePrimary } from '../../../redux/slices/ui/nav';
import ROUTES from '../../Routes/constants';
import StyledHeader from './Styles';
import { COOKIES } from '../../../_shared/constants/cookies';
import { createCookie, getCookie } from '../../../_shared/utils/cookies';
import AccessIBeService from '../../../services/AccessIBeService';

const Header = () => {
  const [{ items, position, context }, auth] = useSelector(
    state => [state?.ui?.nav?.primary, state[ReducerConstants.AUTH]],
    shallowEqual
  );
  const dispatch = useDispatch();
  const locale = renderLocale(auth);
  const { pathname } = useLocation();
  const filteredItems = filterNavItems(items, auth);
  const mixpanel = MixpanelService.get();
  IntercomService.init(auth?.user);
  AccessIBeService.init();
  mixpanel.setProperties();

  const isRetailRoute =
    window.location.pathname.includes(ROUTES.RETAIL_BASE) ||
    window.location.pathname.includes(ROUTES.RETAIL_PUBLIC_BASE) ||
    window.location.pathname.includes(ROUTES.RETAIL_LOADING);
  const isTIAHRoute = window.location.pathname.includes(ROUTES.TIAH);
  const isOktaRedirectRoute = window.location.pathname.includes(
    ROUTES.OKTA_REDIRECT
  );

  // set cookie - page-referrer URL
  if (pathname !== getCookie(COOKIES.LOCATION)) {
    createCookie(
      COOKIES.LOCATION_REFERRER,
      getCookie(COOKIES.LOCATION) || pathname
    );
    createCookie(COOKIES.LOCATION, pathname);
  }

  useEffect(() => {
    const isPublicRoute =
      window.location.pathname.includes(ROUTES.RETAIL_PUBLIC_BASE) ||
      window.location.pathname.includes(ROUTES.TIAH) ||
      window.location.pathname.includes(ROUTES.RETAIL_LOADING);

    // Make the login call and hydrate the redux store
    if (!isPublicRoute) dispatch(login());
  }, [isRetailRoute, isTIAHRoute, dispatch]);

  if (isRetailRoute || isTIAHRoute || isOktaRedirectRoute) {
    return null;
  }

  return (
    <StyledHeader data-testid="header">
      <Nav testId="nav" position={position} user={auth?.user} variant="Primary">
        {renderNavItems(
          filteredItems,
          pathname,
          updateActivePrimary,
          context,
          locale
        )}
      </Nav>
    </StyledHeader>
  );
};

export default Header;
